import { useState } from "react";
import { taskService } from "@miplatform/api";
import { ATTEMPT_STATUSES, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { ICalendarWorkTemplateBase } from "@miplatform/types";
import { buildSearchQuery, createUUID } from "@miplatform/utils";

const getAttemptsUUID = createUUID();

export const useWorkOrderHoldListViewModel = ({
  calendarId,
  workOrderTemplates,
  filter,
  search,
}: {
  calendarId: string;
  workOrderTemplates: ICalendarWorkTemplateBase[];
  filter?: Record<string, any>;
  search: string;
}) => {
  const stateManager = useComponentState();
  const [attempts, setAttempts] = useState([]);

  const getAttempts = () => {
    stateManager.abort(getAttemptsUUID);
    stateManager.run(async () => {
      const searchQuery = Object.entries(
        buildSearchQuery(search, [
          "home/address/addressLine1",
          "home/communityName",
          "home/builderName",
          "home/address/city",
        ])
      ).map(([key, value]) => ({
        [key]: value,
      }));

      const { status, data } = await taskService.attempts.getAllWorkOrders({
        filters: {
          ...filter,
          and: [
            ...((filter?.and as Record<string, any>[]) || []),
            ...searchQuery,
          ],
          isOrderFollowupDue: false,
          attemptStatus: { eq: ATTEMPT_STATUSES.HOLD },
          assignment: {
            WorkOrder: {
              holdCalendarId: {
                type: "guid",
                value: calendarId,
              },
              WorkOrderTemplateId: {
                in:
                  workOrderTemplates?.map(({ id }) => ({
                    type: "guid",
                    value: id,
                  })) || [],
              },
            },
          },
        },
        sort: "modifiedOn desc",
      });

      if (status === HTTP_STATUSES.OK) {
        setAttempts(data);
      }
    }, getAttemptsUUID);
  };

  return {
    isLoading: stateManager.isBusy(),
    attempts,
    getAttempts,
  };
};
